import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaxSuggestions, NameSuggestionFormat } from './name-suggestion.constants';
import { NameServiceLocation, NameSuggestionResponse } from './name-suggestion.model';

@Injectable()
export class NameSuggestionService {
  constructor(private httpClient: HttpClient) {}

  public getNameSuggestions(text: string, location: NameServiceLocation): Promise<NameSuggestionResponse> {
    const url = encodeURI(
      `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=${NameSuggestionFormat}&text=${text}&maxSuggestions=${MaxSuggestions}&location=${location}`
    );
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: '*/*'
    });

    return this.httpClient
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Error getting name suggestions from a name suggestion service.');
    return Promise.reject(error.message || error);
  }
}
